import IAddress from "./IAddress";
import IBlock3Address from "./IBlock3Address";
import Address from "@/module/main/model/applicationForm/Address";

export default class Block3Address implements IBlock3Address {
    constructor(
        public contactAddress: IAddress = new Address(),
        public permanentAddress: IAddress = new Address(),
        public contactSameAsPermanent: string = "true",
    ) {
    }
}
